<template>
  <el-card v-loading="loading">
    <div slot="header" class="clearfix">
      <el-row :gutter="5">
        <el-col :lg="8">
          Status dos Objetos
        </el-col>
      </el-row>
    </div>
    <el-alert show-icon :closable="false" v-if="bigBarChart.chartData.labels.length === 0"
      description="Sem dados de etiquetas nesse periodo informado" type="warning">
    </el-alert>
    <bar-chart
      v-else
      :height="350"
      ref="bigChart"
      :chart-data="bigBarChart.chartData"
      :extra-options="bigBarChart.extraOptions"
    ></bar-chart>
  </el-card>
</template>
<script>
import BarChart from "@/components/Charts/BarChart";
import { SroService } from "@/services/customers/sro.services";
import moment from "moment";
import "moment/locale/pt-br";

export default {
  name: 'PostSroMainHomeStatus',
  props: ["startedAt", "finishedAt", "customer", "services"],
  created() {
    this.$bus.$on("fetch", this.fetch);
  },
  beforeDestroy() {
    this.$bus.$off("fetch", this.fetch);
  },
  components: {
    BarChart,
  },
  data() {
    return {
      loading: false,
      bigBarChart: {
        chartData: {
          datasets: [],
          labels: [],
        },
      },
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      const vm = this;
      vm.loading = true;
        const s = moment(vm.startedAt);
        const f = moment(vm.finishedAt);

        SroService.status({
          customer: vm.customer,
          services: vm.services,
          startedAt: s.format("YYYY-MM-DD"),
          finishedAt: f.format("YYYY-MM-DD"),
        })
          .then((response) => {
            const chartData = {
              datasets: response.datasets,
              labels: response.labels,
            };
            vm.bigBarChart.chartData = chartData;
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => (vm.loading = false));
    },
  }
}
</script>